/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%}.main[_ngcontent-%COMP%]{min-height:70vh;flex:1;padding-top:0;transition:padding .5s ease-in-out}.app-container[_ngcontent-%COMP%]{margin:0 auto}.banner-space[_ngcontent-%COMP%]{padding-top:50px}.page-loader[_ngcontent-%COMP%]{position:fixed;width:100%;height:100vh;z-index:111111111;display:flex;justify-content:center;align-items:center;background:rgba(255,255,255,.9)}@media (min-width:1100px){.app-container[_ngcontent-%COMP%]{padding-top:0}}"];
export { styles as styles };
